module.exports = __webpack_public_path__ + "img/np.1f5bde8f.jpg";